import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import CommonDialog from '../../../common/CommonDialog';
import useGlobalStore from '../../../store/useGlobalStore';
import ApexAutoAppEmailSettings from './ApexAutoAppEmailSettings';
import AppointmentTextMessages from './AppointmentTextMessages';
import InvoiceEstimateTextMessages from './InvoiceEstimateTextMessages';

const CustomerNotifications = ({ configData }) => {
    const { isSettingsDirty, resetSettingsDirty } = useGlobalStore();

    // Block browser tab close / refresh when dirty
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (isSettingsDirty) {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [isSettingsDirty]);

    // Reset dirty flag when leaving the page (component unmount)
    useEffect(() => {
        return () => {
            resetSettingsDirty();
        };
    }, [resetSettingsDirty]);

    return (
        <Box>
            <ApexAutoAppEmailSettings configData={configData} />
            <AppointmentTextMessages configData={configData} />
            <InvoiceEstimateTextMessages />
        </Box>
    );
};

export default CustomerNotifications;
